import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Toaster } from 'sonner';
import { SiteProvider } from './SiteContext';
import Header from './components/Header';
import Hero from './components/Hero';
import FaviconLoader from './components/FaviconLoader';

// Lazy load sections below the fold
const About = lazy(() => import('./components/About'));
const StockCalculator = lazy(() => import('./components/StockCalculator'));
const TradingJournal = lazy(() => import('./components/TradingJournal'));
const BlogWidget = lazy(() => import('./components/BlogWidget'));
const Classes = lazy(() => import('./components/Classes'));
const LMSPreview = lazy(() => import('./components/LMSPreview'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const StudentResults = lazy(() => import('./components/StudentResults'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));

// Lazy load route-level components
const BlogPost = lazy(() => import('./components/BlogPost'));
const BlogIndex = lazy(() => import('./components/BlogIndex'));
const JournalPage = lazy(() => import('./components/JournalPage'));
const TradingJournalLanding = lazy(() => import('./components/TradingJournalLanding'));
const TradingJournalTutorial = lazy(() => import('./components/TradingJournalTutorial'));
const PanduanTradingJournal = lazy(() => import('./components/PanduanTradingJournal'));
const AdminDashboard = lazy(() => import('./components/AdminDashboard'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./components/TermsConditions'));

const LazyFallback = () => (
  <div className="flex items-center justify-center py-20">
    <div className="w-8 h-8 border-4 rounded-full animate-spin" style={{ borderColor: '#c3d0d7', borderTopColor: '#1ec7a0' }}></div>
  </div>
);

// Home page component
const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Suspense fallback={<LazyFallback />}>
          <About />
          <StockCalculator />
          <TradingJournal />
          <Classes />
          <BlogWidget />
          <LMSPreview />
          <Testimonials />
          <StudentResults />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </>
  );
};

function App() {
  return (
    <Router>
      <SiteProvider>
      <FaviconLoader />
      <div className="App">
        <Suspense fallback={<LazyFallback />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/journal" element={<TradingJournalLanding />} />
            <Route path="/trading-journal" element={<TradingJournalLanding />} />
            <Route path="/trading-journal/app" element={<JournalPage />} />
            <Route path="/trading-journal/tutorial" element={<TradingJournalTutorial />} />
            <Route path="/panduan-trading-journal" element={<PanduanTradingJournal />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privasi" element={<PrivacyPolicy />} />
            <Route path="/terma" element={<TermsConditions />} />
          </Routes>
        </Suspense>
        <Toaster position="top-right" />
      </div>
      </SiteProvider>
    </Router>
  );
}

export default App;
